import API from "../../../../../app/api";


export const getStyleGuide = async () => {
    const res = await API.get(`/pages/style-guide`);

    if (res.data?.status !== 200) {
        throw new Error("Failed to fetch style guide");
    }

    return res.data.data;
};

